import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType, DialogWidget } from '@tableau/widgets';
import React, { ReactElement } from 'react';

import { Messages } from '~src/codegen/Localize';

import { confirmationDialogBodyStyle, confirmationDialogStyle } from './TryTableauAISectionStyles';

interface TryTableauAIConfirmationDialogProps {
    onActivate: () => void;
    onClose: () => void;
    isRestart?: boolean;
}

export function TryTableauAIConfirmationDialog({ onActivate, onClose, isRestart }: TryTableauAIConfirmationDialogProps): ReactElement {
    return (
        <DialogWidget
            testId='try-tableau-ai-modal'
            title={isRestart
                ? Messages.settings_agents_try_tableau_ai_restart_button()
                : Messages.settings_agents_try_tableau_ai_start_button()}
            type={DialogType.NormalWithTitleBar}
            showCloseButton={true}
            onCloseRequest={onClose}
            positioningBehavior={DialogPositioningBehavior.Centered}
            isModal={true}
            shouldAdjustPositionOnWindowResize={true}
            dialogWidth={600}
            dialogStyle={confirmationDialogStyle}
            dialogBodyStyle={confirmationDialogBodyStyle}
            footerContent={
                <DialogFooterButtonsWidget
                    testId='try-tableau-ai-confirmation-dialog-footer'
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            testId: 'try-tableau-ai-confirmation-dialog-cancel-button',
                            handleClick: onClose
                        },
                        {
                            buttonType: ButtonType.Primary,
                            children: isRestart
                                ? Messages.settings_agents_try_tableau_ai_confirmation_dialog_restart_button()
                                : Messages.settings_agents_try_tableau_ai_confirmation_dialog_button(),
                            testId: 'try-tableau-ai-confirmation-dialog-start-button',
                            handleClick: onActivate
                        }
                    ]}
                />
            }
        >
            {Messages.settings_agents_try_tableau_ai_confirmation_dialog_explanatory_text()}
        </DialogWidget>
    );
}